export default {
  init() {
    /***
     * Run The greenway FAQ JS
     */

    $('.cat-container').children('ul').children('li').children('a').click(function (){
      var idName = $(this).attr('class');

      //Add active to the answers class to toggle divs
      $(this).parent('li').parent('ul').find('.active').removeClass('active');
      $(this).addClass('active');
      $('.answers-container').find('.active').removeClass('active');
      $('.answers-container').find('#' + idName).addClass('active');
    });

    $('.question').click(function (){
      $(this).find('i').toggleClass('fa-plus closed  fa-minus open');
      $(this).next('.answer').fadeToggle(600, 'swing');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/faq.js